import { StatusCodes } from 'http-status-codes';
import { LoginData, UserInfo } from '../models';
import { AdminInfo, InviteAdminRequest } from './users';
export * from './templates';
export * from './users';
export * from './companies';
export * from './batches';
export const API = {
    login: {
        path: '/login',
        method: 'POST',
        request: LoginData,
        response: {
            [StatusCodes.OK]: UserInfo,
            [StatusCodes.BAD_REQUEST]: null,
            [StatusCodes.UNAUTHORIZED]: null,
            [StatusCodes.FORBIDDEN]: null,
            [StatusCodes.INTERNAL_SERVER_ERROR]: null,
        },
    },
    user: {
        path: '/user',
        method: 'GET',
        response: {
            [StatusCodes.OK]: UserInfo,
        },
    },
    inviteAdmin: {
        path: '/admins',
        method: 'POST',
        request: InviteAdminRequest,
        response: {
            [StatusCodes.OK]: AdminInfo,
        },
    },
};
//# sourceMappingURL=index.js.map